module.exports = __webpack_public_path__ + "static/imageRight-9a1c0be10973cfeab292d37211aeb125.png";